<template>
	<div class="allorder">
		<!-- <div style="text-align:center;height:100vh;line-height:80vh" v-if="!shophasAuthorization">
			<div style="color:#606266" >{{$t('allorders.notbound')}}
				<router-link style="color:red;text-decoration:none" :to="{name:'index'}">{{$t('allorders.shopx')}}</router-link>
			</div>
		</div> -->
		<div >
			<div style="font-size:22px;margin:10px 0">{{$t('allorders.allorder')}}</div>
			    <div class="condition_box">
					<div class="time_choose">
						<span style="margin-right:20px">{{$t('allorders.rengtime')}}</span>
						<el-date-picker
							v-model="timeValue"
							type="datetimerange"
							size="small"
							value-format="yyyy-MM-dd"
							@change="gerOrder"
							:picker-options="pickerOptions2"
							:range-separator="rangeseparator"
							:start-placeholder="startplaceholder"
							:end-placeholder="endplaceholder"
							align="right">
						</el-date-picker>
					</div>
                	<condition :ConditionOption="ConditionOption" @getOrderParams="getOrderParams"  @getOrderParamsCopy="getOrderParamsCopy"></condition>
					<div style="display:flex;align-items:center;margin-top:15px">
						<span>{{$t('allorders.Orderfind')}}：</span>
						<el-input size="small" style="width:250px;margin:0 8px " @change="searchOrder()"  :placeholder="searplaceholder"  v-model="params.orderId" clearable> </el-input>
						<el-button type="primary" size="small" >{{$t('allorders.find')}}</el-button>
						<div style="margin-left:20px"><el-button size="small" type="primary" @click="exportOrderInfo()">{{$t('allorders.Batcorders')}}</el-button></div>
					</div>
				</div>
				<div class="nodata" v-if="!allOrderList.length" >
					<div v-if="orderstatus !== -1">--{{$t('shippedorder.nodata')}}--</div>
					<div style="color:#606266" v-if="orderstatus == -1">{{$t('allorders.notbound')}}
						<router-link style="color:red;text-decoration:none" :to="{name:'index'}">{{$t('allorders.shopx')}}</router-link>
					</div>
				</div>
				<div class="order-wrapper"  >
					<div class="order-list-item" v-for="(item,index) in allOrderList" :key="index">
						<div class="list-desc">
							<el-tooltip  v-show="item.amend"    effect="light" :content="contentplar" placement="bottom">
								<i class="iconfont icon-sign"></i>
							</el-tooltip>
							<span class="seller">{{$t('shippedorder.orderSn')}}：{{item.orderId}}</span>
							<span class="seller seller-item">{{$t('homeTwo.Orderactuallypaid')}}：<span class="seller-ppc">{{item.escrowAmount}}</span></span>
							<span class="seller seller-item">{{$t('shippedorder.status')}}：<span class="seller-ppc">{{getStatus(item)}}</span></span>
							<span class="seller seller-item">{{$t('lazada.time')}}<i  v-if="item.paymentMethod === 'Cash on Delivery'">(COD)</i>：<span class="seller-ppc">{{getTime(item.createTime)}}</span></span>
							<span class="seller seller-item" v-if="item.payTime">{{$t('homeTwo.Paymenttime')}}：<span class="seller-ppc">{{getTime(item.payTime)}}</span></span>
							<span class="seller seller-item" v-if="item.orderStatus === 'CANCELLED'">
								{{$t('shippedorder.cancelTime')}}
								<span class="seller-ppc">{{getTime(item.updateTime)}}</span>
							</span>
							<span class="seller seller-item" >
								{{$t('shippedorder.delivery_time')}}
								<span class="seller-ppc">{{countTime(item)}}</span>
							</span>
						</div>
						
						<div class="return-desc">
							<div class="return-item" >
								<div class="return-wrpaer">
									<div class="return-item-list" :class="{'unfold' : active !== index}" v-for="ttp in item.items">
										<span class="pic-box" ><img v-image-preview :src="ttp.attributeImage ? ttp.attributeImage : ttp.image"  /></span>
										<div class="pic-box-desc">
											<div class="pic-box-desc-item" v-if="item.platform =='TIKTOK'">{{ ttp.variationSku }} / Label size: {{ ttp.variationName }} | {{ ttp.itemName }}</div>
											<div class="pic-box-desc-item" v-else>{{ ttp.itemName }}</div>
											<div v-if="ttp.storeItem">
												<div class="pic-box-desc-amount" >{{$t('other.a566')}}：{{ttp.storeItem.storeName}}</div>
												<div class="pic-box-desc-amount" >cusCode：{{ttp.storeItem.cusCode}}（{{ttp.storeItem.component ? itemnum : setmeal}}）</div>
												<div  style="margin-top: 5px;font-size:15px" v-if="ttp.storeItem.children !== null && !ttp.storeItem.component">
													<div style="color:red" v-for="(childre,indexTBB) in ttp.storeItem.children" :key="indexTBB">
															{{$t('allorders.theitem')}}({{childre.cusCode}})：{{childre.skuName}}  {{$t('allorders.quantity')}}：{{childre.rate * ttp.variationQuantityPurchased}}
														</div>
													</div>

													<div  style="margin-top: 5px;font-size:15px" v-if="ttp.storeItem.children == null">
														<div style="color:red">
															SKU：{{ttp.storeItem.skuName}}  {{$t('allorders.quantity')}}：{{ttp.variationQuantityPurchased}}
														</div>
													</div>
													<div v-if="ttp.storeItem.additions" style="padding:5px 0px;font-size:15px" >
													<div style="font-size:15px;" v-for="(gift,giftIndex) in ttp.storeItem.additions" :key="giftIndex">
														{{$t('other.a497')}}：{{gift.skuName }}（{{gift.cusCode}}）  {{$t('other.a567')}}：{{gift.rate * ttp.variationQuantityPurchased}}
													</div>
												</div>
											</div>
											<div v-else>
												<div class="pic-box-desc-amount"><span class="pic-box-desc-amount-item">{{$t('shippedorder.sku')}}： {{ttp.storeItem ? ttp.storeItem.skuName : ttp.variationSku}}</span></div>
												<div class="pic-box-desc-amount"><span class="pic-box-desc-amount-item">{{$t('homeTwo.Specificationname')}}：  {{ttp.storeItem ? ttp.storeItem.variationName : description}}</span></div>
											
											
												<div class="pic-box-desc-amount">
													<span class="pic-box-desc-amount-item">{{$t('shippedorder.quantity')}}： x{{ttp.variationQuantityPurchased}}</span>
													<span style="margin-left: 15px;"  v-if="ttp.storeItem  &&  ttp.storeItem.synchrony">{{$t('pendingorder.Inventory')}}:（{{$t('pendingorder.In_warehouse')}}:{{ttp.storeItem ? ttp.storeItem.storeNum : ''}},{{$t('pendingorder.committed')}}:{{ttp.storeItem ? ttp.storeItem.unShipped : ''}},{{$t('pendingorder.on_line')}}:{{ttp.storeItem ? ttp.storeItem.stock : ''}})</span>
												</div>
											</div>
											
											
										</div>
									</div>
								
								</div>
								
								<div style="display: flex;">
									<div class="retrun-reasonr">
										<div class="return-reasonr-desc">{{$t('shippedorder.shopName')}}：{{item.shopName}}</div>
										<div class="return-reasonr-desc">{{$t('shippedorder.shopid')}}：{{item.shopId}}</div>
										<div class="return-reasonr-desc">{{$t('shippedorder.recipient')}}：{{item.address.name}}</div>
										<div class="return-reasonr-desc">{{$t('shippedorder.phone')}}：{{item.address.phone ? item.address.phone : description}}</div>
										
									</div>
									<div class="retrun-reasonr">
										<div class="return-reasonr-desc">{{$t('shippedorder.methods')}}：{{item.shippingCarrier ? item.shippingCarrier : description}}</div>
										<!-- <div class="return-reasonr-desc">{{$t('shippedorder.actually_paid')}}：<span>({{item.currency}}){{item.totalAmount}}</span></div> -->
										<div class="return-reasonr-desc">{{$t('shippedorder.waybill_number')}}：<span>{{item.trackingNo ? item.trackingNo : description}}</span></div>
										<div class="return-reasonr-desc">{{$t('shippedorder.delivery_store')}}：<span>{{item.storeName ? item.storeName : description}}</span></div>
									</div>
								</div>
								<div style="margin-left:20px;padding:0px 20px;" v-if="item.procure&&item.bulkOrder">
									<div style="padding:2px 10px;background-color: #e59926;color: #fff;border-radius:15px;font-size: 14px; width: 60px;text-align: center;">{{$t('other.a3285')}}</div>
									<div><span>{{$t('other.a1273')}}：{{getType(item.bulkOrder.payType)}}</span>
										<span style="margin-left: 10px;" v-if="item.bulkOrder.payType!=1">{{$t('other.a3288')}}{{item.bulkOrder.preFee}}</span>
										<span style="margin-left: 10px;" v-if="item.bulkOrder.payType!=1">{{$t('other.a3289')}}{{item.bulkOrder.finalFee}}</span></div>
									<div v-if="item.bulkOrder.payType!=1">{{$t('other.a3290')}}{{item.bulkOrder.payType!=1?$t('other.a118'):$t('other.a1512')}}</div>
								</div>
								
								<div style="margin-left:20px;padding:0px 20px;" v-if="item.shopName == '自建订单'">
									<div>{{$t('other.a624')}}：{{item.msgToStore}}</div>
								</div>
							</div>
								<div v-if="item.items.length >3 " style="width:100%;text-align: center;border-top: 1px solid #eee;padding-top: 10px;" @click="ttp01(index)">
									
									<span style="margin-left: 15px; color: red;cursor: pointer;" v-if="active !== index"><span class="iconfont icon-xia-down"></span>{{$t('allorders.Morehere')}}</span>
									<span style="margin-left: 15px; color: red;cursor: pointer;" v-else><span class="iconfont icon-xiala1"></span>{{$t('allorders.Hideup')}}</span>
									</div>
						</div>
					</div>
					
					<div v-if="allOrderList.length" class="Pager">
					    <el-pagination
					      @size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage1"
						:page-sizes="[15, 20, 30, 50]"
						:page-size="params.offset"
						layout="total, sizes, prev, pager, next, jumper"
						:total="allCount">
					    </el-pagination>
					  </div>
				</div>
			  
			  
			
			
		</div>
		
		
	</div>
</template>

<script>
	import {mapState, mapActions, mapMutations} from 'vuex'
	import orderApi from '../../../api/moudles/order'
	import Condition from '../../../components/condition'
	import utils from '../../../utils/utils.js'
	export default{
		data(){
			return {
				description:this.$t("allorders.description"),
				setmeal:this.$t("allorders.setmeal"),
				itemnum:this.$t("allorders.item"),
				rangeseparator:this.$t("allorders.until"),
				startplaceholder:this.$t("allorders.starttime"),
				endplaceholder:this.$t("allorders.endtime"),
				searplaceholder:this.$t("allorders.lookup"),
				contentplar:this.$t("allorders.modified"),
				type:0,
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
				allStoreIds:JSON.parse(localStorage.getItem('userInfo')).storeIds,
				allshopIdS:JSON.parse(localStorage.getItem('userInfo')).shopIds,
				offset:15, //每页显示条数
				activeName:'first',
				currentPage1:1,
				inputtext:'',
				all_shop:[],
				order_all:[],
				shopId:'',
				orderstatus:0,
				active:-1,
				itemId:null,
				skuId:null,
				cusCode:null,
				timeValue:[],
				allShopInfo:[],
				pickerOptions2: {
				shortcuts: [{
					text: this.$t("allorders.latestweek"),
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: this.$t("allorders.Lastmonth"),
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: this.$t("allorders.Lastthreemonths"),
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
				},
				ConditionOption:[{
						id:0,
						desc:this.$t("allorders.regions"),
						isActive:0,
						list:[]
					},{
						id:1,
						desc:this.$t("allorders.Platform"),
						isActive:0,
						list:[{
							label:this.$t("allorders.SHOPEE"),
							value:0,
							active:false
						},{
							label:this.$t("allorders.LAZADA"),
							value:1,
							active:false
						},{
							label:'TikTok Shop',
							value:2,
							active:false
						},{
							label:'TEMU',
							value:3,
							active:false
						},{
							label:this.$t("allorders.manualorder"),
							value:4,
							active:false
						}]
					},{
						id:2,
						desc:this.$t("allorders.Sestore"),
						isActive:0,
						list:[]
					},{
						id:3,
						desc:this.$t("allorders.Ordertype"),
						isActive:0,
						list:[{
							label:this.$t("allorders.all"),
							value:-1,
							active:false
						},{
							label:this.$t("allorders.nopayment"),
							value:0,
							active:false
						},{
							label:this.$t("allorders.audit"),
							value:1,
							active:false
						},{
							label:this.$t("allorders.insanity"),
							value:2,
							active:false
						},{
							label:this.$t("allorders.collected"),
							value:5,
							active:false
						},{
							label:this.$t("homeTwo.Courierhasbeendelivered"),
							value:6,
							active:false
						},{
							label:this.$t("homeTwo.Buyerhasconfirmed"),
							value:7,
							active:false
						},{
							label:this.$t("homeTwo.Applicationforcancellation"),
							value:8,
							active:false
						},{
							label:this.$t("homeTwo.Cancelorder"),
							value:9,
							active:false
						},]
					},{
						id:4,
						desc:this.$t("allorders.orderscheduling"),
						isActive:0,
						list:[{
							label:this.$t("homeTwo.Ordertimefromlatetoearly"),
							value:0,
							active:false
						},{
							label:this.$t("homeTwo.Ordertimefrommorningtonight"),
							value:1,
							active:false
						},{
							label:this.$t("homeTwo.Remainingdeliverytimefrommoretoless"),
							value:2,
							active:false
						},{
							label:this.$t("homeTwo.Remainingdeliverytimefromlesstomore"),
							value:3,
							active:false
						},]
					}	
				],
				params:{
					end:null,
					start:null,
					orderId:null,
					orderType:null,
					offset:50,
					page:0,
					shopIds:null,
					sortType:null,
					start:null,
					storeIds:null,
					userId:JSON.parse(localStorage.getItem('userInfo')).userId


				}
			}
		},
		components: {
			Condition
		},
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				allOrderList:state => state.order.allOrder,
				allCount:state => state.order.allCount,
				pendingorderCounts:state => state.order.pendingorderCounts,
				unprocessedorderCounts:state => state.order.unprocessedorderCounts,
			}),
			shippedorder(){
				 return this.$t('shippedorder')
			},
			totalCount(){
				if(this.orderstatus === 0) {
					return this.allCount
				}else if(this.orderstatus === 1) {
					return this.pendingorderCounts
				}else if(this.orderstatus === 3) {
					return this.unprocessedorderCounts
				}else if(this.orderstatus === 4) {
					return this.unprocessedorderCounts
				}else if(this.orderstatus === 5) {
					return this.unprocessedorderCounts
				}
			}
		},
		watch:{
			inputtext(){
				if(this.inputtext === '') {
					this.handleCurrentChange()
				}
			},
			params(){
				alert(123)
			}
					
		},
		created(){
			this.itemId=this.$route.query.itemId
			this.skuId=this.$route.query.skuId
			this.cusCode=this.$route.query.cusCode
			this.init()
		},
		methods: {
			...mapActions('order', [
				'getAllorder',
				'getOrdersBytrickNo',
				'getGoodsOrder',
				'queryAllOrder'
				
			]),
			queryAllOrderSet(params){
				let data = JSON.parse(JSON.stringify(params))
				if(data.orderId&&data.orderId!=''){
					console.log(data)
					let value = JSON.parse(JSON.stringify(data.orderId)).trim()
					if (value.includes(' ')) {
						data.orderIds = value.split(' ')
						if(data.orderIds.length>200){
							this.$message.warning(this.$t('other.a3374'))
							return
						}
						data.orderId = ''
					}else{
						data.orderIds = [value]
					}
				}
				this.queryAllOrder(data);
			},
			getType(index) {
				let obj = {
					1: this.$t('other.a3286'),
					2: this.$t('other.a3287'),
				}
				return obj[index]
			},

			exportOrderInfo(){
				let data = JSON.parse(JSON.stringify(this.params))
				if(data.orderId&&data.orderId!=''){
					console.log(data)
					let value = JSON.parse(JSON.stringify(data.orderId)).trim()
					if (value.includes(' ')) {
						data.orderIds = value.split(' ')
						if(data.orderIds.length>200){
							this.$message.warning(this.$t('other.a3374'))
							return
						}
						data.orderId = ''
					}else{
						data.orderIds = [value]
					}
				}
				data.page = 0
				data.offset = this.allCount
				orderApi
				.getDistrustOrders(
					data
				// 	{
				// 	end:utils.CurdateAddoneday(this.params.end),
				// 	start:this.params.start,
				// 	orderId:null,
				// 	orderType:null,
				// 	hasStoreItem:true,
				// 	offset:this.allCount,
				// 	page:0,
				// 	shopIds:this.params.shopIds,
				// 	sortType:this.params.sortType,
				// 	storeIds:this.params.storeIds,
				// 	userId:JSON.parse(localStorage.getItem('userInfo')).userId
				// }
			)
				.then(res => {
					if(res.code === 200) {
						console.log('8541',res.data)
				// res.data.order.forEach
						// console.log(this.allOrderList,'===>allOrderList')
						// return
						// let data = JSON.parse(JSON.stringify(this.allOrderList))
// return
						
				let arr=[]
				res.data.orders.forEach(p => {
					p.items.forEach((k,index) => {
						k.totalSku=''
						k.totalQty=0
						let num=index+1
						if(k.storeItem && k.storeItem.component ){//单品
							k.totalSku='sku1'+':' +k.storeItem.skuName  + ' */Qty:' + k.variationQuantityPurchased
							k.totalQty=k.variationQuantityPurchased
						}else{//套餐
							if(k.storeItem && k.storeItem.children){
								k.storeItem.children.forEach((j,ttb )=> {
									let vdf=ttb+1
									k.totalSku+='sku'+ vdf + '('+ j.cusCode +')' + ':' +j.skuName  + ' */Qty:' + k.variationQuantityPurchased *j.rate
									k.totalQty+=j.rate*k.variationQuantityPurchased
								})
							}
						}

						arr.push({
							'订单号':p.orderId,
							'运单号':p.trackingNo,
							'状态':p.orderStatus,
							
							'收货人':p.address.name,
							'电话号码':p.address.phone,
							'详细地址':p.address.state + '/' + p.address.city + '/' +p.address.fullAddress,
							'产品名称':k.itemName,
							'单品或套餐':k.storeItem ? k.storeItem.component ? this.$t('other.a251')+k.storeItem.cusCode : this.$t('other.a252') + k.storeItem.cusCode : this.$t('other.a568'),
							'sku详情':k.totalSku,
							'sku数量':k.storeItem ? k.storeItem.component ? 1 : k.storeItem.children.length  : this.$t('other.a568'),
							'购买总数':k.totalQty,
							'实收':k.price,
							'配送方式':p.logistics,
              '店铺名称':p.shopName,
							'下单时间':utils.renderTime(p.createTime),
						})
					})
				})

				let list=['订单号','运单号','状态','收货人','电话号码','详细地址','产品名称','单品或套餐','sku详情','sku数量','购买总数','实收','配送方式','店铺名称','下单时间']
				console.log('arr',arr)
				utils.exPortEXml(arr,list,list)
						
					}else{
						this.$message.warning(res.msg)
					}
					
				})
			},


			getOrderParams(data){
				console.log(data)

				if(data[0].list[data[0].isActive].value !== null){
					this.ConditionOption[2].list=this.allShopInfo.filter(p => {
						if(p.code == data[0].list[data[0].isActive].value){
							return p
						}
					})
				}else{
					this.ConditionOption[2].list=this.allShopInfo
				}
				this.currentPage1=1
				this.params.page=0
				this.params.country=data[0].isActive == 0 ? null :  data[0].list[data[0].isActive].value 
				this.params.platform=data[1].isActive == 0 ? '' :  data[1].isActive == 5 ? 'DXS'  :  data[1].list[data[1].isActive].label
				this.params.platform=this.params.platform == 'TikTok Shop' ? 'TIKTOK' : this.params.platform
				this.params.shopIds=data[2].isActive == 0 ? this.allshopIdS : [data[2].list[data[2].isActive].value]
				this.params.storeIds=this.allStoreIds 
				this.params.orderType=data[3].list[data[3].isActive].value
				this.params.sortType=data[4].list[data[4].isActive].value

				console.log(this.params)
				this.queryAllOrderSet(this.params)
			},


			getOrderParamsCopy(data){
				console.log('店铺多选',data)
				let shopIds=[]
				data[2].list.forEach(p => {
					if(p.active){
						shopIds.push(p.value)
					}
				})
				this.currentPage1=1
				this.params.page=0
				this.params.shopIds=shopIds
				this.params.orderType=data[3].list[data[3].isActive].value
				this.params.sortType=data[4].list[data[4].isActive].value
				this.queryAllOrderSet(this.params)
				console.log('shopIds',this.params)
			},

			gerOrder(){
				this.params.start=this.timeValue[0]
				this.params.end=utils.CurdateAddoneday(this.timeValue[1])
				this.queryAllOrderSet(this.params)
			},

			searchOrder(){
			
				this.queryAllOrderSet(this.params)
			},
			//剩余发货时间
			 countTime(item){
			 	 if(!item.shipByDate){
			 		 return this.$t('other.a354')
			 	 }
			 		 let lasttime=utils.renderTime(item.shipByDate)
			 		
			 		 let day=''
			 		 let hour=''
			 		 let minute=''
			 		 let second=''
			 		 const end = Date.parse(new Date(lasttime))
			 		 const now = Date.parse(new Date())
			 		 
			 		 if (now >= end) {
			 			day = 0
			 			hour = 0
			 			minute = 0
			 			second = 0
			 			return "0"
			 		 }
			 		 
			 		 const msec = end - now
			 		 let d = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
			 		 let h = parseInt(msec / 1000 / 60 / 60 % 24)//算出小时数
			 		 let m = parseInt(msec / 1000 / 60 % 60)//算出分钟数
			 		 let s = parseInt(msec / 1000 % 60)//算出秒数
			 		
			 		 day = d
			 		 hour = h > 9 ? h : '0' + h
			 		 minute = m > 9 ? m : '0' + m
			 		 second = s > 9 ? s : '0' + s
			 		 const that = this
			 		 return day + this.$t('pendingorder.day') + hour+ this.$t('pendingorder.hours') + minute +this.$t('other.a569')
			 				 
			 				
			},

			ttp01(num){
				if(this.active == num) {
					this.active=-1
				}else{
					this.active=num
				}
			},

			handleClick(tab, event,name) {
			  this.$router.replace(tab.name);
			  this.activeName = tab.name;
			},
			
			getOrderByShopId(){
				console.log(this.shopId)
				this. handleCurrentChange()
			},
			getOrderByStatus(){
				console.log(this.orderstatus)
				this. handleCurrentChange()
			},
			
			init(){
				// if(!this.shophasAuthorization){
				// 	return
				// }

				let countryList=utils.getCountryCodeByUser()
				countryList.forEach(p => {
					this.ConditionOption[0].list.push({
						label:utils.conutryConversion(p),
						value:p,
						active:false
					})
				})
				
				this.timeValue=[utils.getRecentSevenDay(-30),utils.getRecentSevenDay(1)]
				console.log(this.all_shop)
				if(true){//已经绑定shopee商店
				let lazadaShops=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
				let shopeeShops=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
				let tiktokShops=JSON.parse(localStorage.getItem('userInfo')).tiktokShops
				let temuAuth=JSON.parse(localStorage.getItem('userInfo')).temuAuth
				
				if(temuAuth !== null && temuAuth.length>0 ){
					temuAuth.forEach(p => {
						this.all_shop.push({
							label:p.shopName,
							value:p.shopId,
							active:false
						})
				

						this.ConditionOption[2].list.push({
							label:p.shopName,
							code:p.shopSite,
							value:p.shopId,
							active:false
						})
					})
				}
				
				if(tiktokShops !== null && tiktokShops.length>0 ){
					tiktokShops.forEach(p => {
						this.all_shop.push({
							label:p.shopName,
							value:p.shopId,
							active:false
						})
				

						this.ConditionOption[2].list.push({
							label:p.shopName,
							code:p.region,
							value:p.shopId,
							active:false
						})
					})
				}

				if(lazadaShops !== null && lazadaShops.length>0 ){
					lazadaShops.forEach(p => {
						this.all_shop.push({
							label:p.name,
							value:p.sellerId,
							active:false
						})
				

						this.ConditionOption[2].list.push({
							label:p.name,
							code:p.country,
							value:p.sellerId,
							active:false
						})
					})
				}

				if(shopeeShops !== null && shopeeShops.length>0){
					shopeeShops.forEach(p => {
						this.all_shop.push({
							label:p.shopName,
							value:p.shopId,
							active:false
						})

						this.ConditionOption[2].list.push({
							label:p.shopName,
							value:p.shopId,
							code:p.country,
							active:false
						})
					})
				}


				this.allShopInfo=this.ConditionOption[2].list
				   this.ConditionOption[1].list.unshift({
					   label:this.$t("allorders.all"),
					   value:null,
					   active:false
				   })

				   this.ConditionOption[2].list.unshift({
					   label:this.$t("allorders.all"),
					   value:null,
					   active:false
				   })

				    this.ConditionOption[0].list.unshift({
					   label:this.$t("allorders.all"),
					   value:null,
					   active:false
				   })

				   this.params.shopIds=this.allshopIdS
				   this.params.storeIds=this.allStoreIds
				   this.params.start=this.timeValue[0]
				   this.params.end=this.timeValue[1]
				   this.params.hasStoreItem=true
				   this.params.orderType=this.ConditionOption[3].list[0].value
				   this.params.sortType=this.ConditionOption[4].list[0].value
				   this.params.platform=''
				   console.log(this.params)
				 
				
				    console.log(this.ConditionOption)
					console.log('-=-=1-=-')
					console.log(this.all_shop)
					this.order_all=utils.getOrderStatus()
					console.log(this.order_all)
					this.shopId=this.all_shop.length>0?this.all_shop[0].value:''
					if(this.itemId !== undefined){
						this.getGoodsOrder({
							itemId:Number(this.itemId),
							offset:15,
							page:0,
							skuId:Number(this.skuId),
							sortType:5,
							type:0
						})
					}else if(this.cusCode !== undefined){
						this.getGoodsOrder({
							cusCode:Number(this.cusCode),
							offset:15,
							page:0,
							sortType:5,
							type:0
						})
					}else{
						this.queryAllOrderSet( this.params)
					}

				}else{
					this.orderstatus=-1
					this.shopId=this.all_shop[0].value
					this.order_all=[{
						value:-1,
						label:this.$t("other.a354")
					}]
					
					
					
				}
				
				
				
			},
			
			//获取卖家帐号下所有的订单
			//控制每页显示订单条数
			handleSizeChange(val) {
						 console.log(`每页 ${val} 条`);
						 this.offset=parseInt(`${val}`)
						  this.params.offset=parseInt(`${val}`)
						 this.handleCurrentChange()
		  },
		  //显示当前第几页
		  handleCurrentChange(val) {
						 this.currentPage1=parseInt(`${val}`)
						 this.params.page= parseInt(`${val}`) ?    (parseInt(`${val}`) -1) *  this.params.offset : 0
						  this.queryAllOrderSet(this.params)	
						
							
		  },
		  
		  //输入搜索
		  gotosearch(){
			const params= {
				orders:this.inputtext,
				type:0
			}
			this.getOrdersBytrickNo(params)
		  },
		  
		  getStatus(item){
			  const params={
				  0:this.$t("homeTwo.Unpaid"),
				  1:this.$t("storePending.tobeshipped"),
				  2:this.$t("homeTwo.Courierhasbeencollected"),
				  3:this.$t("homeTwo.Courierhasbeendelivered"),
				  4:this.$t("homeTwo.Buyerhasconfirmed"),
				  5:this.$t("homeTwo.Applicationforcancellation"),
				  6:this.$t("problemorder.tap_canceled"),
				  7:this.$t("problemorder.tap_return"),
				  8:this.$t("other.a3373"),
			  }
			  let ttp=null
			  if(item.orderType == 1 && !item.storeId) {
				  ttp=this.$t("homeTwo.Pendingreview")
			  }else if(item.orderType == 1 && item.storeId){
				  ttp=this.$t("homeTwo.Audited")
			  }else{
				  ttp=params[item.orderType]
			  }
			return ttp
		
			
		  },
		  getTime(item){
			  return utils.renderTime(item)
		  },
			 
			
		}
		
	}
</script>

<style >
	
	.title-enter-active{
		transition: all .3s ease;
	}
	
	.title-leave-active {
	  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	
	.title-enter, .title-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */ {
	  transform: scale(0.5)
	  /* opacity: 0; */
	}
	
	.allorder {
		/* flex: 1;
		margin: 60px 0 0 235px; */
		
	}

	.allorder .time_choose{
		display: flex;
		align-items: center;
		padding-bottom: 20px;
		
	}
	.allorder .order-list-item {
			position: relative;
			padding-bottom: 10px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}
	
		.allorder .order-title,
		.allorder .order-query {
			display: flex;
			justify-content: space-between;
	
			padding: 10px 0;
			border-bottom: 1px #E0E0E0 solid;
		}
	
	
		.allorder .order-query .query {
			position: relative;
			margin-right: 30px;
		}
	
		.allorder .list-btn {
			padding: 20px 15px;
		}
	
		.allorder .list-desc {
			margin-left: 15px;
			border-bottom: 1px #eee solid;
		}
	
		.allorder .list-desc-item {
			font-size: 14px;
	
			padding-right: 15px;
		}
	
		.allorder .list-item-status {
			color: red;
		}
	
		.allorder .didan {
			font-size: 24px;
		}
	
		.allorder .list-content {
			display: flex;
			justify-content: space-around;
			/* margin: 20px;
		padding: 20px; */
			/* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
		}
	
		.allorder .order-pic {
			width: 80px;
			height: 80px;
		}
	
		img {
			width: 100%;
		}
	
		.allorder .list-content-left,
		.allorder .list-content-right {
			display: flex;
			
		}
	
		.allorder .list-item-wrapper {
			box-sizing: border-box;
			padding: 15px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}
		.allorder .order-selec{
			width: 150px;
			margin: 0 10px;
		}
		.allorder .block-ttp{
			width: 350px !important;
		}
		.allorder .order-desc{
			width: 30%;
	
		}
		
		.allorder .order-title-desc{
			margin-bottom: 15px;
		}
		.allorder .list-price-item,.shoper-name{
			padding: 2px 0;
		}
		.allorder .list-number,.list-price{
			margin-left: 40px;
		}
		.allorder .primary-btn{
			display: inline-block;
			margin: 0 30px;
		}
		.allorder .loading{
			position: absolute;
			z-index: 9999;
		}
		
		.allorder .second-menu{
			display: flex;
			justify-content: space-between;
			    padding-left: 20px;
	
		}
		.allorder .menu-right-btn{
			margin-right: 30px;
		}
		.allorder .second-menu-left{
			flex: 1;
			display: flex;
			padding: 0 10px;
			
		}

		.condition_box{
			padding-bottom: 5px;
			border-bottom: 1px solid #eeee;
		}
		
		.allorder .search-box{
			width: 100px;
			margin: 0 10px 0px 10px;
		}
		.allorder .order-wrapper{
			margin-top: 20px;
			margin-bottom: 80px;
		}
		
		.allorder .sousuo-box{
			width: 400px;
		}
		
		.allorder .chekbox {
		    width: 30px;
		    height: 30px;
		}
		
		.allorder .nodata{
			margin-top: 100px;
			text-align: center;
			color: #000;
		}
		
		.allorder .Pager{
		position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
		
		.allorder .order-title-count{
			color: red;
			font-style: inherit;
			margin-left: 10px;
		}
		.allorder .logistics-header{
			font-size: 18px;
			margin-bottom: 10px;
		}
		
	/* 	新起点 */
		
		.allorder .list-desc {
			display: flex;
			align-items: center;
			margin-left: 15px;
			border-bottom: 1px #eee solid;
		}
		
		.allorder .pendingorder .chekbox{
			width: 30px;
			height: 30px;
			line-height: 30px;
		}
		
		.allorder .pic-box{
				display: flex;
			    margin: 2px;
				width: 80px;
				height: 80px;
		}
		.allorder .return-item{
			display: flex;
			justify-content: flex-start;
			box-sizing: border-box;
			padding: 10px;
		}
		.allorder .return-item-list{
			display: flex;
			align-items: center;
		}
		.allorder .pic-box-desc{
			width: 350px;
			margin-left: 20px;
		}
		.allorder .retrun-reasonr{
			margin-left: 30px;
		}
		.allorder .retrun-reasonr-btn{
			display: flex;
			flex-direction: column;
			align-items: center ;
			margin-right: 20px;
		}
		.allorder .seller{
			margin-right: 10px;
			font-size: 18px;
		}
		.allorder .return-reasonr-desc{
			box-sizing: border-box;
			padding: 3px 0;
		}
		.allorder .seller-item{
			margin-left: 15px;
			font-size: 14px;
		}
		.allorder .seller-ppc{
			color: red;
		}
		
		.allorder .img-box{
			display: flex;
		}
		
		.allorder .unfold:nth-of-type(n+4){
			display: none;
			
		}
</style>
